import React, { useMemo } from 'react'
import type { EventGQL } from '../../../../Api'
import {
  getBroadcastImg,
  getGameTime,
  getShortDate,
  mapEventsByMarket,
} from '../../../../Utils'
import { Broadcaster, ListCon, ListOuterCon } from './styles'
import { Con } from '../../../../Components/Layout/Containers/ConStyles'
import { DayGamesSection } from '../weekBox/weekStyles'
import { Head3 } from '../../../../Components/Typography/Text.styles'
import { TeamsCol } from '../weekBox/TeamsCol'
import { TableRowAnimation } from '../../../../Components/Animations/ListAnimations'
import { TicketsIconButton } from '../weekBox/HeaderActions/ticketSelector/TicketsIconButton'
type TableParams = {
  events: EventGQL[]
}

export const ListView: React.FC<React.PropsWithChildren<TableParams>> = ({ events }) => {
  const wkEventsByMarket = useMemo(() => {
    if (events.length === 0) return null
    return mapEventsByMarket(events)
  }, [events])

  return (
    <ListOuterCon>
      {wkEventsByMarket &&
        Object.keys(wkEventsByMarket).map((market, index) => (
          <DayGamesSection key={market}>
            <div className="headerRow">
              <Head3 sideMargins={2}>{market}</Head3>
              <div className="tixIcon">
                <TicketsIconButton
                  event={wkEventsByMarket[market][0]}
                  week={wkEventsByMarket[market][0].week}
                  waitList={false}
                  uiTheme={'light'}
                />
              </div>
            </div>
            <ListCon>
              <table className="table">
                <tbody>
                  {wkEventsByMarket[market].map((event) => (
                    <TableRowAnimation key={event.slugname} index={index}>
                      <td>{`${getShortDate(event.startTime)} | ${getGameTime(event.startTime)} ET`}</td>
                      <td>
                        <TeamsCol description={event.description} event={event} />
                      </td>
                      <td>
                        {event.broadcaster.length > 0 && event.broadcaster[0] !== '' && (
                          <Con noMargin noPadding justify="center">
                            {getBroadcastImg(event.broadcaster).map((img, idx) => (
                              <Broadcaster key={idx} src={img} alt="broadcaster image" />
                            ))}
                          </Con>
                        )}
                      </td>
                    </TableRowAnimation>
                  ))}
                </tbody>
              </table>
            </ListCon>
          </DayGamesSection>
        ))}
    </ListOuterCon>
  )
}
